import { memo } from 'react';
import { Text, TextProps } from '@chakra-ui/react';

const CountryCodeDisplayComponent = ({
  code,
  ...props
}: { code: string } & TextProps) => (
  <Text whiteSpace="nowrap" {...props}>
    +{code}
  </Text>
);

export const CountryCodeDisplay = memo(CountryCodeDisplayComponent);
